export default __webpack_public_path__ + "static/media/missouri.506c795b.jpg";